<div class="row">
    <div class="col-lg-12 col-xl-10 offset-xl-1">


        <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="onSubmit()">

            <h3 class="mb-30">Company details</h3>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Business name</label>
                <div class="col-12 col-sm-9">
                    <input [ngClass]="{'is-invalid' : form['controls'].name.invalid && form['controls'].name.touched}"
                        type="text" class="form-control bordered" formControlName="name" placeholder="Business name">
                    <div class="invalid-feedback">Business name required</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Website address</label>
                <div class="col-12 col-sm-9">
                    <input type="text" class="form-control bordered" formControlName="url"
                        placeholder="Website address">
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Email</label>
                <div class="col-12 col-sm-9">
                    <input [ngClass]="{'is-invalid' : form['controls'].email.invalid && form['controls'].email.touched}"
                        type="text" class="form-control bordered" formControlName="email" placeholder="Email">
                    <div class="invalid-feedback">Enter a valid email</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Mobile</label>
                <div class="col-12 col-sm-9">
                    <ys-phone-input formControlName="mobile"></ys-phone-input>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Landline</label>
                <div class="col-12 col-sm-9">
                    <ys-phone-input formControlName="landline"></ys-phone-input>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Company Number</label>
                <div class="col-12 col-sm-9">
                    <input type="text" class="form-control bordered" formControlName="companyNumber"
                        placeholder="Company number">
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">VAT Number</label>
                <div class="col-12 col-sm-9">
                    <input type="text" class="form-control bordered" formControlName="vatNumber"
                        placeholder="VAT number">
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                </div>
                <div class="col-6 text-end">
                    <button [disabled]="!form.valid" type="submit" class="btn btn-round btn-primary">
                        Continue
                    </button>
                </div>
            </div>

        </form>
    </div>
</div>